module.exports = __webpack_public_path__ + "media/images/ln-img4-efbdc1a69d93cf17a00b1d00a146cfa0.png";